import { TStyleProps } from '../../types/TStyleProps';

// Todo: Find a way to runtime type check?

const styleProps: TStyleProps = {
  color: 'color',
  bg: 'bg',
  backgroundColor: 'backgroundColor',
  borderColor: 'borderColor',
  m: 'm',
  margin: 'margin',
  mt: 'mt',
  marginTop: 'marginTop',
  mb: 'mb',
  marginBottom: 'marginBottom',
  ml: 'ml',
  marginLeft: 'marginLeft',
  mr: 'mr',
  marginRight: 'marginRight',
  my: 'my',
  marginY: 'marginY',
  mx: 'mx',
  marginX: 'marginX',
  p: 'p',
  padding: 'padding',
  pt: 'pt',
  paddingTop: 'paddingTop',
  pb: 'pb',
  paddingBottom: 'paddingBottom',
  pl: 'pl',
  paddingLeft: 'paddingLeft',
  pr: 'pr',
  paddingRight: 'paddingRight',
  py: 'py',
  paddingY: 'paddingY',
  px: 'px',
  paddingX: 'paddingX',
  textStyle: 'textStyle',
  borderWidth: 'borderWidth',
  borderRadius: 'borderRadius',
  boxShadow: 'boxShadow',
};

export default styleProps;
